export const moduleName = 'student';